import CustomerService from '../../services/CustomerService'

export default {
  namespaced: true,
  state: {
    customer: {},
    configs: {},
    error: false,
    isLoading: false,
  },
  getters: {
    getCustomer: state => state.customer,
    getConfigs: state => state.configs,
    isLoading: state => state.isLoading,
  },
  actions: {
    getCustomer ({commit}, domain) {
      commit('getCustomer')
      CustomerService.getByDomain(domain)
        .then((res) => {
          commit('getCustomerSuccess', res.data)
        })
        .catch(() => {
          commit('getCustomerError')
        })
    }
  },
  mutations: {
    getCustomer (state) {
      state.isLoading = true
      state.customer = {}
      state.configs = {}
    },
    getCustomerSuccess (state, customerData) {
      state.isLoading = false
      state.customer = customerData.customer
      state.configs = customerData.attributes
    },

    getCustomerError (state) {
      state.error = true
      state.isLoading = false
    },
  }
}
